import useFadeInOnScroll from '../../hooks/useFadeInOnScroll.js';

export default function FadeIn({ as: Tag = 'div', className = '', children, ...rest }) {
  const [ref, visible] = useFadeInOnScroll();
  return (
    <Tag
      ref={ref}
      className={`fade-in ${visible ? 'is-visible' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
}
